import { createSelector } from 'reselect'
import { State } from 'index'

const authSelector = (state: State) => state.auth

export const getIsAdmin = createSelector([authSelector], (state) => state.is_admin)
export const getIsSignedIn = createSelector([authSelector], (state) => state.is_signed_in)
export const getMails = createSelector([authSelector], (state) => state.mails)
export const getRole = createSelector([authSelector], (state) => state.role)
export const getAuthShopRef = createSelector([authSelector], (state) => state.shop_ref)
export const getBrandRef = createSelector([authSelector], (state) => state.brand_ref)
export const getStoreRef = createSelector([authSelector], (state) => state.store_ref)
export const getRoles = createSelector([authSelector], (state) => state.roles)
export const getSwitchingStoreRefs = createSelector([authSelector], (state) => state.switching_store_refs)
export const getUid = createSelector([authSelector], (state) => state.uid)
export const getStaffDeviceTokens = createSelector([authSelector], (state) => state.device_tokens)
export const getStaffPushSettings = createSelector([authSelector], (state) => state.push_settings)
export const getTopTab = createSelector([authSelector], (state) => state.top_tab)
export const getDefaultBreadTypes = createSelector([authSelector], (state) => state.default_bread_types)
